import { type PropsWithChildren, useMemo } from 'react';

import type { ChartData } from '../../core/types/chart-data.js';
import { SankeyDataContext } from '../context/SankeyData.context.js';
import { buildSankeyGraph } from '../utils/build-sankey-graph.js';

interface SankeyDataProviderProps {
  data: ChartData;
  sourceAccessor: string;
  targetAccessor: string;
  valueAccessor: string;
  nodes?: ChartData;
  nodeIdAccessor?: string;
  nodeLabelAccessor?: string;
  columnAccessor?: string;
}

export const SankeyDataProvider = ({
  data,
  sourceAccessor,
  targetAccessor,
  valueAccessor,
  nodes,
  nodeIdAccessor,
  nodeLabelAccessor,
  columnAccessor,
  children,
}: PropsWithChildren<SankeyDataProviderProps>) => {
  const graph = useMemo(
    () =>
      buildSankeyGraph({
        data,
        sourceAccessor,
        targetAccessor,
        valueAccessor,
        nodes,
        nodeIdAccessor,
        nodeLabelAccessor,
        columnAccessor,
      }),
    [
      data,
      sourceAccessor,
      targetAccessor,
      valueAccessor,
      nodes,
      nodeIdAccessor,
      nodeLabelAccessor,
      columnAccessor,
    ],
  );

  return (
    <SankeyDataContext.Provider value={graph}>
      {children}
    </SankeyDataContext.Provider>
  );
};

SankeyDataProvider.displayName = 'SankeyDataProvider';
